"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapEventToAction = exports.GAME_COMPLETE = exports.GAME_START = undefined;

var _game = require("../actions/game");

var actions = _interopRequireWildcard(_game);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var GAME_START = exports.GAME_START = "game-start";
var GAME_COMPLETE = exports.GAME_COMPLETE = "game-complete";

var mapEventToAction = exports.mapEventToAction = function mapEventToAction(event) {
  switch (event) {
    case GAME_START:
      return actions.gameStart();

    case GAME_COMPLETE:
      return actions.gameComplete();

    default:
      return null;
  }
};